export default "__VITE_ASSET__CkrpMsNH__"